import React from "react";
import { contactInfo, contactperson } from "../data/mockData";
import { MapPin, Mail, Phone, Globe, Clock } from "lucide-react";

const Contact = () => {
  return (
    <div className="bg-white min-h-screen">
      {/* Page Header */}
      <div className="bg-blue-950 py-16 text-center overflow-hidden">
        <h1 className="relative text-4xl sm:text-5xl md:text-6xl font-extrabold text-white mb-4 tracking-wider">
          CONTACT US
        </h1>
        <div className="relative w-32 sm:w-48 h-1 bg-primary-600 mx-auto"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="text-center mb-12">
          <p className="text-xl text-gray-700">
            Get in touch with us for any queries regarding TG-SMART 2026
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          <div className="bg-white rounded-xl shadow-xl p-6 text-center hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border-t-4 border-blue-600">
            <div className="text-blue-600 mb-4 flex justify-center">
              <MapPin size={40} />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">Address</h3>
            <p className="text-gray-700 text-sm leading-relaxed">
              {contactInfo.organization}
            </p>
            <p className="text-gray-600 text-sm mt-2">{contactInfo.address}</p>
          </div>

          <div className="bg-white rounded-xl shadow-xl p-6 text-center hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border-t-4 border-blue-600">
            <div className="text-blue-600 mb-4 flex justify-center">
              <Mail size={40} />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">Email</h3>
            <a
              href={`mailto:${contactInfo.email}`}
              className="text-primary-600 hover:text-primary-800 font-semibold"
            >
              {contactInfo.email}
            </a>
          </div>

          <div className="bg-white rounded-xl shadow-xl p-6 text-center hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 border-t-4 border-blue-600">
            <div className="text-blue-600 mb-4 flex justify-center">
              <Globe size={40} />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-3">Website</h3>
            <a
              href={contactInfo.website}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-600 hover:text-primary-800 font-semibold break-words"
            >
              {contactInfo.website}
            </a>
          </div>
        </div>

        {/* Co-Convenor Contacts with Images */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-2">
            Contacts of Coordinators
          </h2>
          <div className="w-32 h-1 bg-primary-600 mx-auto mb-8"></div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {contactperson.map((convenor) => (
              <div
                key={convenor.id}
                className="bg-primary-50 rounded-xl shadow-xl p-6 text-center border-t-4 border-primary-600 hover:shadow-2xl transition-shadow"
              >
                <img
                  src={convenor.image}
                  alt={convenor.name}
                  className="w-32 h-32 rounded-full object-cover border-4 border-primary-600 shadow-lg mx-auto mb-4"
                />
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  {convenor.name}
                </h3>
                <p className="text-primary-700 font-semibold text-sm mb-1">
                  {convenor.designation}
                </p>
                <p className="text-gray-600 text-sm mb-4">
                  {convenor.organization}
                </p>
                <div className="space-y-2">
                  <div className="flex items-center justify-center gap-2 text-gray-700">
                    <Phone size={16} className="text-primary-600" />
                    <a
                      href={`tel:${convenor.phone}`}
                      className="hover:text-primary-600 font-semibold"
                    >
                      {convenor.phone}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Map */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-2">Location</h2>
          <div className="w-24 h-1 bg-primary-600 mb-6"></div>
          <div className="rounded-xl overflow-hidden shadow-2xl border-4 border-beige-200">
            <iframe
              title="Integral University Location"
              src={contactInfo.mapUrl}
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>

        {/* Conference Secretariat */}
        <div className="bg-primary-50 rounded-xl p-8 border-l-4 border-primary-600">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            Conference Secretariat
          </h2>
          <p className="text-gray-700 mb-6 text-lg leading-relaxed">
            For any queries related to paper submission, registration,
            accommodation, or general information, please feel free to contact
            us.
          </p>
          <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-blue-500">
            <div className="flex items-center gap-3 mb-3">
              <Clock size={24} className="text-blue-600" />
              <h4 className="font-bold text-gray-800 text-xl">Office Hours</h4>
            </div>
            <div className="space-y-1 text-gray-700">
              <p>
                <strong>Monday - Friday:</strong> 9:00 AM - 4:00 PM (IST)
              </p>
              <p>
                <strong>Saturday:</strong> 9:00 AM - 12:20 PM (IST)
              </p>
              <p>
                <strong>Sunday:</strong> Closed
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
